import DateInput from "../DateInput";
import DateTimeInput from "../DateTimeInput";
import { FIELD_STATE, isRequiredFieldState } from "../../utils";

const TextInput = ({ fieldState, value, onChange, placeholder, type = "text", hasError = false, hasWarning = false, icon = null, disabled = false, inRow = false, ...rest }) => {
  const stringValue = value ?? "";
  const hasValue = stringValue !== "";
  const isRequired = isRequiredFieldState(fieldState);

  if (fieldState === FIELD_STATE.DISABLE) return null;

  const isRequiredEmpty = isRequired && !hasValue;
  const isDateLike = type === "datetime-local" || type === "time" || type === "month" || type === "week";

  return (
    <div className={inRow ? "relative flex-1" : "relative"} {...rest}>
      {type === "date" && (
        <DateInput
          ghost
          value={stringValue}
          onChange={(date) => onChange({ target: { value: date } })}
          placeholder={placeholder}
          disabled={disabled}
          hasError={hasError}
          hasWarning={hasWarning}
          isRequiredEmpty={isRequiredEmpty}
        />
      )}
      {type === "datetime-local" && (
        <DateTimeInput
          value={stringValue}
          onChange={(dateTime) => onChange({ target: { value: dateTime } })}
          className={`field-input px-2 py-1 font-sans${!hasValue ? (isRequiredEmpty ? " text-orange-400" : " text-gray-400") : ""}${icon ? " pr-10" : ""} [&::-webkit-calendar-picker-indicator]:cursor-pointer`}
          data-state={hasError ? "error" : isRequiredEmpty ? "required" : undefined}
          disabled={disabled}
          autoComplete="off"
        />
      )}
      {type !== "date" && type !== "datetime-local" && (
        <input
          type={type}
          value={stringValue}
          onChange={onChange}
          placeholder={placeholder}
          className={`field-input px-2 py-1 font-sans${isDateLike && !hasValue ? (isRequiredEmpty ? " text-orange-400" : " text-gray-400") : ""}${icon ? " pr-10" : ""}${isDateLike ? " [&::-webkit-calendar-picker-indicator]:absolute [&::-webkit-calendar-picker-indicator]:inset-0 [&::-webkit-calendar-picker-indicator]:h-full [&::-webkit-calendar-picker-indicator]:w-full [&::-webkit-calendar-picker-indicator]:cursor-pointer [&::-webkit-calendar-picker-indicator]:opacity-0" : ""}`}
          data-state={hasError ? "error" : isRequiredEmpty ? "required" : undefined}
          disabled={disabled}
          autoComplete="off"
        />
      )}
      {icon && <div className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2">{icon}</div>}
    </div>
  );
};

export default TextInput;
